module.exports = __webpack_public_path__ + "img/bg26.bee8424c.jpg";